import { Typography } from '@design-system/components/typography/typography';
import { sprinkles } from '@design-system/sprinkles.css';
import { clsx } from 'clsx';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const EmptyStateGuideInfo = ({
  name,
  type,
  guideLink,
}: {
  name: string;
  type: 'Subscription' | 'Paid programs';
  guideLink: string;
}) => (
  <div
    className={clsx(
      'flex flex-col gap-2 p-6 rounded-[20px] w-full',
      sprinkles({ bg: 'P-20' }),
    )}
  >
    <Typography variant="headline" size="small">
      Hey {name}! Let's get you set up for success! 🚀
    </Typography>
    <Typography variant="body" size="large" fontWeight="normal">
      Here is our {type} success checklist - our exact recommendation for how to
      get setup quickly, and answers all your key questions
    </Typography>
    <a className="w-max mt-2" href={guideLink} target="_blank" rel="noreferrer">
      <div
        className={clsx(
          'flex gap-2 px-4 py-2 rounded-[10px]',
          sprinkles({ bg: 'P-80', color: 'W-100' }),
        )}
      >
        <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
        <Typography>Guide</Typography>
      </div>
    </a>
  </div>
);
